import { Box, Button, Table, Tbody, Td, Th, Thead, Tr, Flex, Divider, Text, HStack, Link, Icon } from "@chakra-ui/react";
import moment from "moment";
import { CgTrash } from "react-icons/cg";
import TablePaginator from "../../components/TablePaginator";
import { BsEyeFill, BsEyeSlashFill, BsLink45Deg } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { toggleOrderDetailModal } from "../../actions/orderActions";

const OrdersTable = ({ data, loading, listOrders, markAsReadHandler, archiveHandler }) => {
    const dispatch = useDispatch();
    const getFormattedDate = (date) => {
        moment.locale('es')
        const data = moment(date).format('MM/DD/YYYY')
        return data
    }

    const openOrderDetailModal = (order) => {
        dispatch(toggleOrderDetailModal(order))
    }

    if (loading) return (
        <Flex w='100%' justifyContent='center' alignItems='center' flexDir='column'>
            <Text mr='.3em'>Cargando...</Text>
        </Flex>
    )

    if (data?.docs?.length === 0) return (
        <Flex w='100%' justifyContent='center' alignItems='center' flexDir='column'>
            <Text mr='.3em'>No se encontraron pedidos nuevos</Text>
        </Flex>
    )

    return (
        <Box overflowX="auto" w='100%' py='20px'>
            <Table className="productusers">
                <Thead>
                    <Tr>
                        <Th w="20%">Cliente</Th>
                        <Th w="20%">Email</Th>
                        <Th w="10%">#Productos</Th>
                        <Th w="10%">Status</Th>
                        <Th w="10%">Fecha</Th>
                        <Th w="10%"></Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {data?.docs?.map((order) => (
                        <Tr 
                            key={order._id}
                            bg={order.status === 'Nueva' ? 'green.100' : ''}
                            opacity={order.status === 'Nueva' ? '1' : '.5'}
                        >
                            <Td>{order.customerName}</Td>
                            <Td>{order.customerEmail}</Td>
                            <Td>
                                <Button
                                    as={Link}
                                    colorScheme='blue'
                                    variant='link'
                                    p='0'
                                    onClick={() => openOrderDetailModal(order)}
                                >
                                    {order.items.length}
                                    <Icon as={BsLink45Deg} ml='5px' />
                                </Button>

                            </Td>
                            <Td>{order.status}</Td>
                            <Td>{getFormattedDate(order.createdAt)}</Td>
                            <Td>
                                <HStack>
                                    {
                                        order.status === 'Nueva' ? (
                                            <Button
                                                title="Marcar como leído"
                                                size='sm'
                                                colorScheme='green'
                                                variant='outline'
                                                onClick={() => markAsReadHandler(order)}
                                            >
                                                <BsEyeFill />
                                            </Button>
                                        ) : (
                                            <Button
                                                title="Marcar como no leído"
                                                size='sm'
                                                colorScheme='red'
                                                variant='outline'
                                                onClick={() => markAsReadHandler(order)}
                                            >
                                                <BsEyeSlashFill />
                                            </Button>
                                        )
                                    }
                                    <Button
                                        title="Archivar"
                                        size='sm'
                                        colorScheme='blue'
                                        variant='outline'
                                        onClick={() => archiveHandler(order)}
                                    >
                                        <CgTrash />
                                    </Button>
                                </HStack>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            <Flex flexDir='column' mt='20px'>
                <Divider mb='20px' />
                <TablePaginator
                    totalDocs={data.totalDocs}
                    limit={data.limit}
                    totalPages={data.totalPages}
                    page={data.page}
                    pagingCounter={data.pagingCounter}
                    hasPrevPage={data.hasPrevPage}
                    hasNextPage={data.hasNextPage}
                    prevPage={data.prevPage}
                    nextPage={data.nextPage}
                    listProducts={listOrders}
                    searchTerm={null}
                />
            </Flex>
        </Box>
    )
}

export default OrdersTable;
